import styled from 'styled-components'

interface IBudgetCategoryAttributesCardStyledProps {}

export const BudgetCategoryAttributesCardStyled = styled.div<IBudgetCategoryAttributesCardStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
